module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.boxBool || _vm.showBoxZoom),
      expression: "boxBool || showBoxZoom"
    }],
    class: _vm.styleClass,
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Box Tools:")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: ({
        html: 'Delete'
      }),
      expression: "{ html: 'Delete' }",
      arg: "top"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.deleteBox
    }
  }, [_c('v-icon', [_vm._v("")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: ({
        html: 'Zoom In'
      }),
      expression: "{ html: 'Zoom In' }",
      arg: "top"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.zoomIn
    }
  }, [_c('v-icon', [_vm._v("")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: ({
        html: 'Zoom Out'
      }),
      expression: "{ html: 'Zoom Out' }",
      arg: "top"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.zoomOut
    }
  }, [_c('v-icon', [_vm._v("")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d94699a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/boxTools.vue
// module id = 1282
// module chunks = 1